import { MessageSquare, Pill, Package, AlertTriangle, ShieldAlert, Bell } from 'lucide-react';

/** Shared category → icon/label/color mapping for the Feed list and detail sheet. */
export const CATEGORY_META = {
  message: { label: 'Message', icon: MessageSquare, cls: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400' },
  refill: { label: 'Refill request', icon: Pill, cls: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400' },
  otc_order: { label: 'Online order', icon: Package, cls: 'bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-400' },
  adr: { label: 'Reaction report', icon: AlertTriangle, cls: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400' },
  recall: { label: 'Recall', icon: ShieldAlert, cls: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400' },
  task: { label: 'Alert', icon: Bell, cls: 'bg-slate-100 text-slate-700 dark:bg-slate-500/15 dark:text-slate-300' },
};

export const timeAgo = (iso) => {
  if (!iso) return '';
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
};
